import { ReactNode } from 'react';
import { DarkModeProvider } from '../../contexts/DarkModeContext';
import { LanguageProvider } from '../../contexts/LanguageContext';

/** Layout 상단 빈 그리드 없이 Provider만 필요한 페이지용. */
const SimpleProviders = ({ children }: { children: ReactNode }) => (
  <DarkModeProvider>
    <LanguageProvider>{children}</LanguageProvider>
  </DarkModeProvider>
);

export default SimpleProviders;
